/**
 * Permission / role codes — mirror BE `TmFood.Application.Constants.PermissionCodes`
 * and `RoleCodes`. Wire values stay dot-form (`sales.manage`).
 */

/** BE `PermissionCodes`. */
export const PermissionCodes = {
  SysUserList: "sys.user.list",
  SysUserManage: "sys.user.manage",
  SysRoleList: "sys.role.list",
  SysRoleManage: "sys.role.manage",
  SysOrgList: "sys.org.list",
  SysOrgRead: "sys.org.read",
  SysOrgManage: "sys.org.manage",
  SysPlantList: "sys.plant.list",
  SysPlantManage: "sys.plant.manage",
  SysLineList: "sys.line.list",
  SysLineManage: "sys.line.manage",
  SysAreaList: "sys.area.list",
  SysAreaManage: "sys.area.manage",
  SysShiftList: "sys.shift.list",
  SysShiftManage: "sys.shift.manage",
  SysCategoryList: "sys.category.list",
  SysCategoryManage: "sys.category.manage",
  SysMobileAppReleaseList: "sys.mobileapprelease.list",
  SysMobileAppReleaseManage: "sys.mobileapprelease.manage",
  SysEmailLogList: "sys.emaillog.list",
  SysMfaList: "sys.mfa.list",
  SysMfaManage: "sys.mfa.manage",
  SysNumberingList: "sys.numbering.list",
  SysNumberingManage: "sys.numbering.manage",
  SysSettingList: "sys.setting.list",
  SysSettingManage: "sys.setting.manage",
  SysApprovalPolicyList: "sys.approvalpolicy.list",
  SysApprovalPolicyManage: "sys.approvalpolicy.manage",
  SysAuditRead: "sys.audit.read",
  SysNotifyManage: "sys.notify.manage",
  SysNavManage: "sys.nav.manage",
  MdmItemRead: "mdm.item.read",
  MdmItemManage: "mdm.item.manage",
  MdmUomList: "mdm.uom.list",
  MdmUomManage: "mdm.uom.manage",
  MdmWarehouseList: "mdm.warehouse.list",
  MdmWarehouseManage: "mdm.warehouse.manage",
  MdmLocationList: "mdm.location.list",
  MdmLocationManage: "mdm.location.manage",
  MdmEquipmentList: "mdm.equipment.list",
  MdmEquipmentManage: "mdm.equipment.manage",
  MdmPartnerList: "mdm.partner.list",
  MdmPartnerManage: "mdm.partner.manage",
  MdmDefectList: "mdm.defect.list",
  MdmDefectManage: "mdm.defect.manage",
  MdmReasonList: "mdm.reason.list",
  MdmReasonManage: "mdm.reason.manage",
  MdmLossTypeList: "mdm.losstype.list",
  MdmLossTypeManage: "mdm.losstype.manage",
  MdmPartnerSegmentList: "mdm.partnersegment.list",
  MdmPartnerSegmentManage: "mdm.partnersegment.manage",
  EngBomApprove: "eng.bom.approve",
  EngBomManage: "eng.bom.manage",
  EngProductList: "eng.product.list",
  EngProductManage: "eng.product.manage",
  EngProductTypeList: "eng.producttype.list",
  EngProductTypeManage: "eng.producttype.manage",
  EngPackFormatList: "eng.packformat.list",
  EngPackFormatManage: "eng.packformat.manage",
  EngBomList: "eng.bom.list",
  EngTechnicalInfoList: "eng.technicalinfo.list",
  EngTechnicalInfoManage: "eng.technicalinfo.manage",
  EngTechnicalInfoApprove: "eng.technicalinfo.approve",
  EngRoutingList: "eng.routing.list",
  EngRoutingManage: "eng.routing.manage",
  EngRoutingApprove: "eng.routing.approve",
  EngOperationTemplateList: "eng.operationtemplate.list",
  EngOperationTemplateManage: "eng.operationtemplate.manage",
  EngSpecList: "eng.spec.list",
  EngSpecManage: "eng.spec.manage",
  EngSpecApprove: "eng.spec.approve",
  EngQcPlanList: "eng.qcplan.list",
  EngQcPlanManage: "eng.qcplan.manage",
  EngQcPlanApprove: "eng.qcplan.approve",
  MesOperationExecute: "mes.operation.execute",
  MesBatchList: "mes.batch.list",
  MesBatchRead: "mes.batch.read",
  MesBatchManage: "mes.batch.manage",
  MesHoldList: "mes.hold.list",
  MesHoldManage: "mes.hold.manage",
  MesCipList: "mes.cip.list",
  MesCipManage: "mes.cip.manage",
  MesHandoffList: "mes.handoff.list",
  MesHandoffManage: "mes.handoff.manage",
  MesReworkList: "mes.rework.list",
  MesReworkManage: "mes.rework.manage",
  MesLossList: "mes.loss.list",
  MesHoldRelease: "mes.hold.release",
  MesEbrClose: "mes.ebr.close",
  PlnDemandList: "pln.demand.list",
  PlnDemandManage: "pln.demand.manage",
  PlnOrderList: "pln.order.list",
  PlnOrderRead: "pln.order.read",
  PlnOrderManage: "pln.order.manage",
  PlnReservationList: "pln.reservation.list",
  PlnReservationManage: "pln.reservation.manage",
  /** Policy OR: reservation.manage | wms.txn.post — cấp phát NVL mẻ. */
  PlnBatchIssue: "pln.batch.issue",
  WmsLotList: "wms.lot.list",
  WmsLotManage: "wms.lot.manage",
  WmsBalanceList: "wms.balance.list",
  WmsExpiryList: "wms.expiry.list",
  WmsExpiryManage: "wms.expiry.manage",
  WmsCountList: "wms.count.list",
  WmsCountManage: "wms.count.manage",
  WmsDisposalList: "wms.disposal.list",
  WmsDisposalManage: "wms.disposal.manage",
  WmsTransactionList: "wms.transaction.list",
  WmsTransactionManage: "wms.transaction.manage",
  WmsReservationList: "wms.reservation.list",
  WmsReservationManage: "wms.reservation.manage",
  WmsTxnPost: "wms.txn.post",
  WmsStockRead: "wms.stock.read",
  WmsStockManage: "wms.stock.manage",
  TrcTraceList: "trc.trace.list",
  TrcTraceManage: "trc.trace.manage",
  DocMasterList: "doc.master.list",
  DocMasterManage: "doc.master.manage",
  DocInstanceList: "doc.instance.list",
  DocInstanceManage: "doc.instance.manage",
  DocAttachmentList: "doc.attachment.list",
  DocAttachmentManage: "doc.attachment.manage",
  DocFormRead: "doc.form.read",
  DocFormManage: "doc.form.manage",
  QmsInspectionList: "qms.inspection.list",
  QmsInspectionExecute: "qms.inspection.execute",
  QmsIqcList: "qms.iqc.list",
  QmsFqcList: "qms.fqc.list",
  QmsNcrList: "qms.ncr.list",
  QmsNcrManage: "qms.ncr.manage",
  QmsDeviationList: "qms.deviation.list",
  QmsDeviationManage: "qms.deviation.manage",
  QmsReleaseList: "qms.release.list",
  QmsReleaseDecide: "qms.release.decide",
  ExeApprovalList: "exe.approval.list",
  ExeApprovalAct: "exe.approval.act",
  ExeKpiRead: "exe.kpi.read",
  ExeAlertList: "exe.alert.list",
  ExeReportList: "exe.report.list",
  BiRead: "bi.read",
  BiProdList: "bi.prod.list",
  BiQcList: "bi.qc.list",
  BiWhList: "bi.wh.list",
  BiProdKpis: "bi.prod.kpis",
  BiProdOutput: "bi.prod.output",
  BiProdLoss: "bi.prod.loss",
  BiProdFunnel: "bi.prod.funnel",
  BiProdOtif: "bi.prod.otif",
  BiProdWip: "bi.prod.wip",
  BiProdLive: "bi.prod.live",
  BiQcKpis: "bi.qc.kpis",
  BiQcTrend: "bi.qc.trend",
  BiQcDefectDonut: "bi.qc.defect_donut",
  BiQcFunnel: "bi.qc.funnel",
  BiQcMatrix: "bi.qc.matrix",
  BiQcCcp: "bi.qc.ccp",
  BiQcLive: "bi.qc.live",
  BiWhKpis: "bi.wh.kpis",
  BiWhFlowChart: "bi.wh.flow_chart",
  BiWhStockDonut: "bi.wh.stock_donut",
  BiWhFunnel: "bi.wh.funnel",
  BiWhExpiry: "bi.wh.expiry",
  BiWhZones: "bi.wh.zones",
  BiWhLive: "bi.wh.live",
  SalesOrderList: "sal.order.list",
  SalesOrderManage: "sal.order.manage",
  FinReceiptList: "fin.receipt.list",
  FinReceiptManage: "fin.receipt.manage",
  FinPaymentList: "fin.payment.list",
  FinPaymentManage: "fin.payment.manage",
  /** FIN-09 — lịch sử PartnerTransaction (read-only). */
  FinTransactionList: "fin.transaction.list",
  /** FIN-10 — báo cáo công nợ Partner & đơn (read-only). */
  FinDebtReport: "fin.debt.report",
  SalesShipmentList: "sal.shipment.list",
  SalesShipmentManage: "sal.shipment.manage",
  SalesView: "sales.view",
  SalesManage: "sales.manage",
  PurchaseRequisitionList: "pur.requisition.list",
  PurchaseOrderList: "pur.order.list",
  PurchaseView: "purchase.view",
  PurchaseManage: "purchase.manage",
  PurchaseRequest: "purchase.request",
  ApprovalAct: "approval.act",
} as const;

export type PermissionCode =
  (typeof PermissionCodes)[keyof typeof PermissionCodes];

export const PermissionCodeValues = Object.values(PermissionCodes);

/** BE `RoleCodes`. */
export const RoleCodes = {
  Admin: "ROLE_ADMIN",
  QuanDoc: "ROLE_QD",
  Qc: "ROLE_QC",
  NvSx: "ROLE_NV_SX",
  Kho: "ROLE_KHO",
  KeHoach: "ROLE_KE_HOACH",
  Bgd: "ROLE_BGD",
  Qa: "ROLE_QA",
  KinhDoanh: "ROLE_KINH_DOANH",
  MuaHang: "ROLE_MUA_HANG",
} as const;

export type RoleCode = (typeof RoleCodes)[keyof typeof RoleCodes];
